import { CAN_USE_DOM } from '../constants';

export const dataLayerEvents = {
	/**
	 * @param label {String}
	 */
	onShareBtnClick: label =>
		CAN_USE_DOM &&
		window.dataLayer &&
		window.dataLayer.push({
			event: 'content_share',
			click_text: label,
		}),
	onSearchWithResults: () => CAN_USE_DOM && window.dataLayer && window.dataLayer.push({ event: 'content_click', click_text: 'שם הנופל' }),
	onSearchWithoutResults: () =>
		CAN_USE_DOM && window.dataLayer && window.dataLayer.push({ event: 'content_click_not_found', click_text: 'שם הנופל' }),
	onFormSent: () =>
		CAN_USE_DOM &&
		window.dataLayer &&
		window.dataLayer.push({
			event: 'form_sent',
			click_text: 'שם הנופל',
		}),
	onContentClick: text =>
		CAN_USE_DOM &&
		window.dataLayer &&
		window.dataLayer.push({
			event: 'content_click',
			click_text: text,
		}),
	mainPage: () =>
		CAN_USE_DOM &&
		window.dataLayer &&
		window.dataLayer.push({
			event: 'page_view',
			page_location: window.location.href,
			page_title: document.title,
		}),
};
